export enum DOCUMENT_TAG_TYPES {
  BODY = 'body',
  HEAD = 'head',
}
